export default Object.freeze({
    MENU_EVENT_TYPE_MOUSEOVER: 1,
    MENU_EVENT_TYPE_MOUSEOUT: 2,
    MENU_EVENT_TYPE_CLICK: 3
})